<template>
  <div class="blog-article">
    <div class="mb-5">
      <button class="btn" @click="$emit('clear')">
        <i class="icon-chevron-left"></i>
        Voltar
      </button>
    </div>

    <h3 class="text-center text-uppercase">{{ article.title }}</h3>
    <div class="d-flex justify-content-center align-items-center mt-4">
      <i class="fas fa-clock mr-2"></i> {{ readSpeed }} minutos de leitura
    </div>
    <div
      class="img-cover my-5"
      :style="`background-image: url(${article.cover})`"
    ></div>
    <div class="text-light article-description" v-html="article.description" />
  </div>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    article: {
      type: Object,
      default: null
    }
  },
  computed: {
    readSpeed() {
      const wordsPerMinute = 250;
      const lettersPerWord = 4.5;
      return Math.ceil(
        get(this.article, "description", "").length /
          (wordsPerMinute * lettersPerWord)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-article {
  button {
    display: flex;
    align-items: center;
    gap: 12px;
    color: white;
    font-size: 16px;
    font-weight: bold;
    padding: 8px;
    min-height: unset !important;
    i {
      font-size: 20px;
      color: rgba(130, 130, 130, 1);
    }
    transition: 0.2s all;
    &:hover {
      background-color: rgba(130, 130, 130, 0.1);
    }
  }

  .img-cover {
    width: 100%;
    height: 0;
    padding-bottom: 40%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    border-radius: 4px;
  }
  h3 {
    font-size: 24px;
    font-weight: 800;
  }

  .article-description {
    ::v-deep * {
      color: #f8f9fa !important;
      background: none !important;
    }
  }
}
</style>
